import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { createJoiWithTranslations } from '../../utils/joiConfig';
import { Select, FormRow } from '@efast_public/fjd-component-library';
import { Zustellwege } from '../../api/govos.types';
import {
  BehoerdenpostfachFormProps,
  ZustellwegSubFormProps
} from './Zustellweg.types';
import { useZustellwegForm } from './useZustellwegForm';

const getDefaultValues = (data?: Zustellwege): BehoerdenpostfachFormProps => ({
  serviceId: data?.serviceId || 0
});

const getValidationSchema = (
  CustomJoi: ReturnType<typeof createJoiWithTranslations>
) =>
  CustomJoi.object<BehoerdenpostfachFormProps>({
    serviceId: CustomJoi.string().required()
  });

export function BehoerdenpostfachForm({
  zustellwege,
  serviceIndex,
  deliveryServices,
  ...props
}: ZustellwegSubFormProps) {
  const filteredDeliveryServices =
    deliveryServices?.filter((s) => s.serviceCode === 'a3behoerdenpostfach') ??
    [];
  const { t } = useTranslation();
  const CustomJoi = createJoiWithTranslations(t);

  const { control, handleSubmit } = useForm<BehoerdenpostfachFormProps>({
    defaultValues: getDefaultValues(zustellwege?.at(serviceIndex)),
    resolver: joiResolver(getValidationSchema(CustomJoi)),
    mode: 'onBlur'
  });

  useZustellwegForm({
    zustellwege,
    serviceIndex,
    deliveryServices,
    ...props,
    handleSubmit
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <FormRow label={t('EditTransportConfigModal.fields.behoerdenpostfach')}>
        <Controller
          name="serviceId"
          control={control}
          render={({ field }) => (
            <Select
              value={field.value}
              onChange={(value) => {
                const selectedValue = value.at(0)?.value;
                field.onChange(selectedValue);
              }}
              options={
                filteredDeliveryServices?.map((s) => ({
                  value: String(s.serviceId),
                  label: s.title
                })) ?? []
              }
              defaultOptions={
                serviceIndex > -1
                  ? (filteredDeliveryServices
                      ?.filter(
                        (s) =>
                          String(s.serviceId) ===
                          String(zustellwege?.at(serviceIndex)?.serviceId)
                      )
                      .map((s) => ({
                        value: String(s.serviceId),
                        label: s.title
                      })) ?? [])
                  : []
              }
              onBlur={() => field.onBlur()}
              name={field.name}
              placeholder={
                filteredDeliveryServices?.length === 0
                  ? t('select.noOptionsAvailable')
                  : t('EditTransportConfigModal.fields.selectBehoerdenpostfach')
              }
              disabled={filteredDeliveryServices?.length === 0}
            />
          )}
        />
      </FormRow>
    </div>
  );
}
